<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text="Competencia Planilha IRPF" />

      <Lynx-Button
        text="Cadastrar"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="showModalCompetencia()"
      />
    </div>

    <b-table :columns="columns" :data="lista_controle_irpf" paginated per-page="10">
      <template slot-scope="props" v-if="props.row.id != null"  >
               <b-table-column field="id" >
     {{ props.row.id  }}
        </b-table-column>

        <b-table-column field="nome" >
     {{ props.row.nome  }}
        </b-table-column>

        <b-table-column field="competencia">
          {{ props.row.competencia | formatEnToBr }}
        </b-table-column>

        <b-table-column field="created_at">
          {{ props.row.created_at | formatEnToBr }}
        </b-table-column>

        <b-table-column field="acoes">
          <Lynx-Button
            class=""
            icon-size="7"
            icon="ArrowRight"
            size="small"
            @click.native="enterCompetencia(props.row)"
          />
        </b-table-column>
      </template>
      <template v-slot:empty>
        <NotFoundData text="Nenhum convite encontrado!" />
      </template>
    </b-table>

    <b-modal :active.sync="modalCompetencia">
      <div class="bg-white p-5" style="height: 460px">
        <Lynx-Title text="Competencia da Planilha" />

        <div class="flex w-full" style="z-index: 999">
          <label class="flex flex-col w-full">
            <Lynx-Label label="Data de competência" />
            <Lynx-Input
              type="text"
              placeholder="digite ano competencia"
              v-model="form.competencia"
            />
          </label>
        </div>

        <div>
          <b-button
            @click.native="hideModalCompetencia()"
            type="is-danger"
            class="mt-4"
            >Cancelar</b-button
          >
          <b-button
            @click.native="createCompTeb()"
            type="is-primary"
            class="ml-4 mt-4"
            >Salvar</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { formatEnToBr } from "@/utils/momentHelpers";

import { monthNames } from "@/utils/utils";
import moment from "moment";
import { hasRole } from "@/utils/can";

import { mapGetters } from "vuex";

export default {
  components: { NotFoundData },
  data() {
    return {
      monthNames,

      form: { competencia: null},
      modalCompetencia: false,
      selectedFiles: [],
      loading: false,
      pasta_selected: null,
      isPressing: false,
      timer: null,
      preciona: 0,
      editavel: 0,
      columns: [
        {
          field: "id",
          label: "ID",
          searchable: true,
          sortable: true,
        },
        
        {
          field: "nome",
          label: "Nome",
        },

        {
          field: "competencia",
          label: "Competencia",
        },
        {
          field: "created_at",
          label: "criação",
        },

        {
          field: "acoes",
          label: "Ações",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),

    lista_controle_irpf() {
      return this.$store.state.controleIrpf.lista_controle_irpf_comp;
    },
    mensagem_alert() {
      return this.$store.state.controleIrpf.mensagem_alert;
    },
  },
  mounted() {
    this.listarCompTabs();
  },
  filters: {
    formatEnToBr,
  },
  methods: {
    hasRole,
    enterCompetencia(tabela) {
      if(!this.hasRole('super-admin') && moment(tabela.competencia).add(1,'year').add('6','months').format("YYYY-MM-DD") < moment(new Date()).format("YYYY-MM-DD")){

        this.$snack.warning("Apenas competencia atual");
      }else{
      this.$router.push({
        name: "controle-irpf.index",
        params: { comp_id: tabela.id },
      });
    }
    },
    hideModalCompetencia() {
      this.modalCompetencia = false;
    },

    showModalCompetencia() {
      this.modalCompetencia = true;
    },
    async createCompTeb() {
      // this.loading = true;

        await this.$store
          .dispatch("controleIrpf/create_controle_irpf_comp", this.form)
          .then(() => {
            this.$snack.success(this.mensagem_alert.message);
          })
          .catch((err) => {
            this.$snack.error("erro " + err);
          })
          .finally(() => {
            this.hideModalCompetencia();
            this.loading = false;
          });
          this.listarCompTabs()
    },
    async listarCompTabs() {
      this.loading = true;

      await this.$store.dispatch("controleIrpf/listar_controle_irpf_comp");
      this.loading = false;
    },
    handleClick(tipo, value) {
      // Ação ao clicar (clique duplo)

      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${value}/open?token=${this.getToken}`
      );
    },
  },
};
</script>

<style scoped>
</style>
  